module.exports = ".has-errors {\r\n    border:1px solid red;\r\n}\r\n.radio_flex {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n"